module.exports = __webpack_public_path__ + "static/media/internet-of-things03.7facdc8b.jpg";